import React, { useRef } from "react";
import { ChevronLeft, ChevronRight, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

export default function ContentRow({ title, seeAllHref, children, testId, gradientAccent = false }) {
  const ref = useRef(null);
  const scroll = (dir) => {
    if (!ref.current) return;
    const w = ref.current.clientWidth * 0.85;
    ref.current.scrollBy({ left: dir * w, behavior: "smooth" });
  };

  return (
    <section className="mt-10 md:mt-14" data-testid={testId}>
      <div className="flex items-end justify-between px-4 md:px-10 mb-4">
        <h2 className={cn(
          "font-display text-2xl md:text-3xl font-bold tracking-tight",
          gradientAccent && "ycn-gradient-text"
        )}>{title}</h2>
        <div className="flex items-center gap-2">
          {seeAllHref && (
            <Link to={seeAllHref} data-testid={`${testId}-see-all`} className="text-sm text-white/60 hover:text-white flex items-center gap-1 transition">
              See All <ArrowRight size={14} />
            </Link>
          )}
          <div className="hidden md:flex items-center gap-2 ml-2">
            <button onClick={() => scroll(-1)} aria-label="Scroll left"
              className="h-9 w-9 rounded-full ycn-glass hover:bg-white/10 flex items-center justify-center text-white/80">
              <ChevronLeft size={16} />
            </button>
            <button onClick={() => scroll(1)} aria-label="Scroll right"
              className="h-9 w-9 rounded-full ycn-glass hover:bg-white/10 flex items-center justify-center text-white/80">
              <ChevronRight size={16} />
            </button>
          </div>
        </div>
      </div>
      <div ref={ref} className="row-scroll flex gap-4 overflow-x-auto scroll-smooth px-4 md:px-10 pb-2">
        {children}
      </div>
    </section>
  );
}
